export default{
    //GMT时间转标准时间
    GMTToStr(time){
        let date = new Date(time)
        let Str=date.getFullYear() + '-' +
        (date.getMonth() + 1) + '-' +
        date.getDate() + ' ' +
        date.getHours() + ':' +
        date.getMinutes() + ':' +
        date.getSeconds()
        return Str
    },
    //太平时间转换为标准时间
    formateDate(datetime) {
        function addDateZero(num) {
            return (num < 10 ? "0" + num : num);
        }
        let d = new Date(datetime);
        let formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate())+' '+addDateZero(d.getHours())+':'+addDateZero(d.getMinutes()+':'+addDateZero(d.getSeconds()));
        return formatdatetime;
    },
    //太平时间转换为标准时间带小时分钟
    formateDate2(datetime) {
        function addDateZero(num) {
            return (num < 10 ? "0" + num : num);
        }
        let d = new Date(datetime);
        let formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate())+' '+ addDateZero(d.getHours())+':'+addDateZero(d.getMinutes())+':'+addDateZero(d.getSeconds());
        return formatdatetime;
    },
}
